require("./vendor/slick");
(function ($) {
  $(function () {
    $(".bs-section--add-progress-bar")
      .not(".bs-section--tab-inner-slider-progress-bar")
      .each((index, element) => {
        const $this = $(element);
        let $slider, $sliderParent;
        if ($this.find(".bs-tab-slider").length) {
          $slider = $this.find(".bs-slider-content");
          $sliderParent = $slider.parent(".bs-tab-slider");
        }
        if ($this.find(".bs-slider").length) {
          $slider = $this.find(".slick-slider");
          $sliderParent = $slider.parent(".bs-slider");
        }
        if (!$this.find(".progress-bar-container").length) {
          $sliderParent.after('<div class="progress-bar-container"><div class="progress-bar-wrapper"><span class="progress-inner"></span></div><span class="progress-bar-slide-count"></span></div>');
        }

        $sliderParent.each((index, ele) => {
          let uniqSliderId = $(ele).attr("id");
          $("#" + uniqSliderId).on("init reInit afterChange", (event, slick) => {
            let currentSlideNumber = (slick.currentSlide ? slick.currentSlide : 0) + 1,
              totalSlideCount = slick.slideCount ? slick.slideCount : 0,
              progressBarValue = (currentSlideNumber / totalSlideCount) * 100 + "%",
              progressBarSlideCount = $("#" + uniqSliderId)
                .parents(".bs-column")
                .find(".progress-bar-slide-count");

            progressBarSlideCount.text(currentSlideNumber + "/" + totalSlideCount);
            $("#" + uniqSliderId)
              .parents(".bs-column")
              .find(".progress-inner")
              .css({
                width: progressBarValue,
              });
          });
        });
      });

    if ($("[data-slick]").length) {
      $("[data-slick]").not(".slick-initialized").slick();
    }

    const autoPlayFunction = () => {
      $("[data-slick]").each((index, ele) => {
        if ($(ele).hasClass("slick-initialized")) {
          slick = $(ele).slick("getSlick");
          if (slick.options.autoplay === true) {
            $(ele).slick("slickPause");
            $(window).on("load", () => {
              $(ele)[0].slick.refresh();
              $(ele).slick("slickPlay");
            });
          }
        }
      });
    };

    autoPlayFunction();

    // tab-slider-title-append-tocontent
    $.each($(".bs-section--common-tab-slider-switch-content-title , .bs-section--who-we-serve-we-keep-tab-slider"), (index, element) => {
      const contentArray = [],
        $this = $(element);
      $.each($this.find(".bs-slider-tabs").find(".slick-slide-wrapper"), (index, ele) => {
        $(ele).children().wrapAll("<div class='title-contents'></div>");
        const $content = $(ele).find(".title-contents");
        contentArray.push($content.clone());
      });

      $.each($this.find(".bs-slider-content").find(".slick-slide-wrapper"), (index, ele) => {
        const $content = $(ele);
        if (!$content.find(".title-content").length) {
          $content.prepend(contentArray[index]);
        }
      });
    });
    // accordion-in-mobile wrap div
    $.each($(".bs-section--common-tab-slider-accordion-mobile .bs-tab-slider"), (index, element) => {
      const windowWidth = $(window).width();
      if (windowWidth < 767) {
        $this = $(element);
        $.each($this.find(".bs-slider-content").find(".slick-slide-wrapper"), (index, ele) => {
          $(ele).children(".media-elements, .bs-div").wrapAll('<div class="wrap-image-content"></div>');
        });
      }
    });

    tabSliderSwitchContentDynamicPaddingTop();
  });

  // goto top location after pagination clicked
  const headerHeight = $("#header").outerHeight() + 100;
  $(document).on("facetwp-loaded", () => {
    if (FWP.loaded && $('.facetwp-load-more').length === 0) {
      $("html, body").animate(
        {
          scrollTop: $(".facetwp-template").offset().top - headerHeight,
        },
        500
      );
    }
  });

  // padding-top-for-tab-slider-title
  $(window).on("load", () => {
    tabSliderSwitchContentDynamicPaddingTop();
  });

  const slickSliderResizeBehavior = () => {
    if ($(".slick-initialized").length) {
      $("[data-slick]").each((index) => {
        $("[data-slick]")[index].slick.refresh();
      });
    }
  };

  $(window).on("resize", () => {
    slickSliderResizeBehavior();
  });

  const tabSliderSwitchContentDynamicPaddingTop = () => {
    $.each($(".bs-section--common-tab-slider-switch-content-title"), (index, element) => {
      const $this = $(element),
        titleHeight = $this.find(".bs-div--title-wrapper").outerHeight() - 38;
      $.each($this.find(".bs-slider-content").find(".bs-div__inner"), (index, ele) => {
        if ($(window).width() > 768) {
          $(ele).css("padding-top", titleHeight + "px");
        } else {
          $(ele).removeAttr("style");
        }
      });
    });
  };
})(jQuery);
